export const GrowthIconDesktop = () => (
  <svg
    width="auto"
    height="500"
    viewBox="0 0 731 609"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M157.726 73.7058L159.48 386.129C159.61 409.3 140.931 428.189 117.76 428.319L44.3384 428.731C21.1673 428.862 2.48875 447.751 2.6188 470.922L3.1509 565.728C3.28095 588.9 22.1703 607.578 45.3415 607.448L554.098 604.593C577.269 604.463 595.948 585.573 595.818 562.402L595.457 498.146C595.327 474.974 576.438 456.296 553.267 456.426L330.151 457.678C306.98 457.808 288.09 439.13 287.96 415.958L287.634 357.812C287.504 334.641 306.182 315.751 329.354 315.621L584.547 314.189C607.718 314.059 626.607 332.738 626.737 355.909L626.763 360.593C626.894 383.764 645.783 402.443 668.954 402.313L699.555 402.141C721.91 402.015 740.135 420.037 740.261 442.392V442.392C740.386 464.748 722.365 482.973 700.009 483.098L693.848 483.133C670.677 483.263 651.999 502.152 652.129 525.323L652.249 546.81C652.379 569.981 671.269 588.66 694.44 588.53L732.729 588.315C755.9 588.185 774.579 569.295 774.449 546.124L773.514 379.526C773.384 356.354 754.494 337.676 731.323 337.806L729.694 337.815C706.522 337.945 687.633 319.267 687.503 296.095L687.451 286.829C687.321 263.658 668.432 244.979 645.26 245.109L494.752 245.954C477.879 246.049 464.125 232.448 464.03 215.575V215.575C463.936 198.703 477.536 184.949 494.409 184.854L702.911 183.684C712.613 183.629 720.522 191.45 720.576 201.151V201.151C720.631 210.853 728.539 218.673 738.241 218.619L746.642 218.572C760.983 218.491 772.544 206.8 772.464 192.459L772.065 121.38C771.935 98.2084 753.045 79.5298 729.874 79.6599L422.746 81.3836C399.575 81.5137 380.897 100.403 381.027 123.574L381.537 214.511C381.637 232.227 367.356 246.669 349.64 246.768V246.768C331.924 246.868 317.482 232.587 317.382 214.871L316.984 143.843C316.882 125.705 302.096 111.084 283.958 111.186V111.186C265.821 111.288 251.2 126.074 251.302 144.211L252.489 355.769C252.551 366.736 243.71 375.676 232.743 375.738V375.738C221.776 375.799 212.836 366.959 212.774 355.992L211.269 87.866C211.139 64.6949 229.818 45.8055 252.989 45.6754L716.634 43.0732C728.444 43.0069 737.965 33.3788 737.899 21.5683V21.5683C737.832 9.75774 728.204 0.237144 716.394 0.303431L145.825 3.50577C122.653 3.63582 103.975 22.5252 104.105 45.6964L105.79 345.899C105.884 362.772 92.2836 376.526 75.4114 376.621V376.621C58.5392 376.715 44.7848 363.115 44.6901 346.242L42.8469 17.8316"
      stroke="url(#paint0_linear_2505:7362)"
      stroke-opacity="0.3"
      stroke-width="1.43757"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M407.075 206.824L317.727 297.18L282.882 262.725L220.521 325.79L194.67 300.227L282.594 211.311L317.438 245.766L381.223 181.261L406.931 181.116L407.075 206.824Z"
      fill="url(#paint1_linear_2505:7362)"
    />
    <path
      d="M406.357 427.898L332.779 428.993C308.46 429.129 276.155 399.522 303.087 360.463L356.713 281.248L335.62 249.912L408.102 249.505L387.362 281.076L439.421 354.616C461.901 390.01 444.869 427.561 406.357 427.898Z"
      fill="url(#paint2_linear_2505:7362)"
    />
    <path
      d="M389.468 276.701L355.383 276.892C352.477 276.909 350.134 279.278 350.151 282.184C350.167 285.09 352.536 287.433 355.442 287.416L389.527 287.225C392.433 287.209 394.776 284.84 394.76 281.934C394.743 279.027 392.374 276.685 389.468 276.701Z"
      fill="url(#paint3_linear_2505:7362)"
    />
    <path
      d="M373.12 401.541C392.475 401.432 408.078 385.653 407.969 366.298C407.861 346.942 392.082 331.339 372.726 331.448C353.371 331.556 337.768 347.335 337.876 366.691C337.985 386.047 353.764 401.649 373.12 401.541Z"
      fill="url(#paint4_linear_2505:7362)"
    />
    <path
      d="M363.543 355.009L373.228 354.954C374.108 354.949 374.979 355.118 375.793 355.451C376.608 355.783 377.348 356.273 377.973 356.892C378.597 357.511 379.093 358.247 379.433 359.059C379.773 359.87 379.949 360.74 379.951 361.619V361.619C379.96 363.392 379.265 365.096 378.019 366.357C376.772 367.617 375.076 368.332 373.303 368.343L363.618 368.397L380.061 381.109"
      stroke="black"
      stroke-width="2.90738"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M363.586 361.536L382.215 361.432"
      stroke="black"
      stroke-width="2.90738"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M363.547 355.009L382.176 354.904"
      stroke="black"
      stroke-width="2.90738"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M475.076 285.182C477.63 286.03 480.388 284.647 481.236 282.094C482.084 279.54 480.701 276.782 478.147 275.934C475.594 275.086 472.836 276.469 471.988 279.022C471.14 281.576 472.522 284.334 475.076 285.182Z"
      stroke="#726BF5"
      stroke-width="0.56697"
    />
    <path
      d="M316.157 194.163C318.196 194.84 320.397 193.736 321.074 191.697C321.751 189.659 320.648 187.458 318.609 186.781C316.571 186.104 314.369 187.207 313.692 189.246C313.015 191.284 314.119 193.486 316.157 194.163Z"
      fill="#FEC8F4"
    />
    <path
      d="M273.47 333.249C275.508 333.926 277.71 332.822 278.387 330.783C279.064 328.745 277.96 326.543 275.922 325.866C273.883 325.189 271.682 326.293 271.005 328.332C270.328 330.37 271.431 332.572 273.47 333.249Z"
      fill="url(#paint5_linear_2505:7362)"
    />
    <path
      d="M524.676 180.532L520.023 180.502C519.167 180.497 518.468 181.187 518.463 182.043L518.432 186.695C518.427 187.552 519.117 188.251 519.973 188.256L524.626 188.286C525.482 188.292 526.181 187.602 526.186 186.746L526.217 182.093C526.222 181.237 525.532 180.538 524.676 180.532Z"
      fill="#FEDD7E"
    />
    <circle
      cx="463.018"
      cy="375.924"
      r="26.1721"
      transform="rotate(-0.321571 463.018 375.924)"
      fill="url(#paint6_linear_2505:7362)"
    />
    <circle
      cx="463.017"
      cy="375.926"
      r="20.3094"
      transform="rotate(-0.321571 463.017 375.926)"
      stroke="black"
      stroke-width="0.636071"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2505:7362"
        x1="631.594"
        y1="-329.86"
        x2="313.285"
        y2="466.161"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9094FF" />
        <stop offset="0.625" stop-color="#989CFD" stop-opacity="0.375" />
        <stop offset="1" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2505:7362"
        x1="417.748"
        y1="153.395"
        x2="214.553"
        y2="340.472"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7C6FF5" />
        <stop offset="1" stop-color="#7C6FF5" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2505:7362"
        x1="415.705"
        y1="406.136"
        x2="197.311"
        y2="415.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A4EFC9" />
        <stop offset="1" stop-color="#A4EFC9" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2505:7362"
        x1="398.817"
        y1="269.035"
        x2="330.844"
        y2="319.311"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#726BF5" />
        <stop offset="1" stop-color="#726BF5" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2505:7362"
        x1="398.585"
        y1="332.052"
        x2="352.245"
        y2="402.599"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2505:7362"
        x1="280.465"
        y1="325.797"
        x2="269.144"
        y2="328.448"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#655CFF" />
        <stop offset="1" stop-color="#655CFF" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2505:7362"
        x1="486.613"
        y1="356.93"
        x2="444.09"
        y2="407.062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFED46" />
        <stop offset="1" stop-color="#FFED46" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);



// WEBPACK FOOTER //
// ./components/homePageNew/growthSection/icon/growthIconDesktop.tsx